import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

const { ProviderActivationMode, PrevisitFormTemplatesMode, ExportFingerprintNote } =
  api.FlowDefinition;

export function UpdateProviderFormFields() {
  const { value: providerActivationMode } = useSelectedNodeField<string>(
    'config.providerActivationMode'
  );
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.firstName"
        label="Provider First Name"
        helperText="Enter the provider's first name"
        placeholder="e.g. {{block.data.firstName}}"
      />
      <BlockValueTemplateField
        fieldName="config.lastName"
        label="Provider Last Name"
        helperText="Enter the provider's last name"
        placeholder="e.g. {{block.data.lastName}}"
      />
      <BlockValueTemplateField
        fieldName="config.email"
        label="Provider Email"
        helperText="Enter the provider's email"
        placeholder="e.g. {{block.data.email}}"
      />
      <BlockValueTemplateField
        fieldName="config.ehrId"
        label="Provider EHR ID"
        helperText="Enter the provider's EHR ID"
        placeholder="e.g. {{block.data.ehrId}}"
      />
      <BlockValueTemplateField
        fieldName="config.hl7Id"
        label="Provider HL7 ID"
        helperText="Enter the provider's HL7 ID (optional)"
        placeholder="e.g. {{block.data.hl7Id}}"
      />
      <BlockValueTemplateField
        fieldName="config.apiId"
        label="Provider API ID"
        helperText="Enter the provider's API ID (optional)"
        placeholder="e.g. {{block.data.apiId}}"
      />
      <BlockRadioGroupField
        fieldName="config.providerActivationMode"
        label="Provider Activation Mode"
        helperText="Choose whether to only update provider information or also activate the provider (changes kind from Provisional to Active and creates scheduled work for encounters)"
        options={[
          { label: 'Update Only', value: ProviderActivationMode.UpdateOnly },
          { label: 'Activate', value: ProviderActivationMode.Activate },
        ]}
        defaultValue={ProviderActivationMode.UpdateOnly}
      />
      {providerActivationMode === ProviderActivationMode.Activate && (
        <>
          <BlockValueTemplateField
            fieldName="config.providerUserId"
            label="Provider User ID (Required)"
            helperText="Required when activating a provider. Uses this user ID instead of looking up by email. Useful when the provider already exists in the system."
            placeholder="e.g. {{block.data.providerUserId}}"
            required={providerActivationMode === ProviderActivationMode.Activate}
          />
          <BlockRadioGroupField
            fieldName="config.previsitFormTemplatesMode"
            label="Previsit Form Templates Mode"
            helperText="Choose whether to automatically apply previsit form templates for this provider"
            options={[
              { label: 'Auto Apply', value: PrevisitFormTemplatesMode.AutoApply },
              { label: 'Manual Apply', value: PrevisitFormTemplatesMode.ManualApply },
            ]}
            defaultValue={PrevisitFormTemplatesMode.ManualApply}
          />
          <BlockSelectField
            fieldName="config.exportFingerprintNoteMode"
            label="Export Fingerprint Note Mode"
            helperText="Choose when to export the fingerprint note for this provider"
            defaultValue={ExportFingerprintNote.Disabled}
            options={[
              { label: 'Disabled', value: ExportFingerprintNote.Disabled },
              { label: 'On Previsit Submit', value: ExportFingerprintNote.OnPrevisitSubmit },
              { label: 'On Check In', value: ExportFingerprintNote.OnCheckIn },
              {
                label: 'On Ready For Provider',
                value: ExportFingerprintNote.OnReadyForProvider,
              },
            ]}
          />
        </>
      )}
    </Stack>
  );
}
